"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _base = _interopRequireWildcard(require("./_base"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var fontSizes = _objectSpread(_objectSpread({}, _base["default"].fontSizes), {}, {
  xxs: "11px",
  xs: "12px",
  s: "13px",
  h1: "20px",
  h2: "18px"
});
var fontWeights = _objectSpread(_objectSpread({}, _base["default"].fontWeights), {}, {
  h2: 400,
  h3: 500
});
var lineHeights = _objectSpread(_objectSpread({}, _base["default"].lineHeights), {}, {
  base: 1.4,
  headings: 1.2,
  h2: 1.16
  // messages: 1.2,  // TODO: move in message component
});

var borderRadius = _objectSpread(_objectSpread({}, _base["default"].borderRadius), {}, {
  s: "3px",
  base: "5px"
});
var icons = {
  select: "ChevronDown"
};

// const iconFonts = {
//   icons: {
//     fontFamily: "airturn-icons",
//     classPrefix: "icon-",
//   },
//   cto: {
//     fontFamily: "cto-icons",
//     classPrefix: "icon_cto--",
//   },
// };

var fields = _objectSpread(_objectSpread({}, _base["default"].fields), {}, {
  fontSize: "14px",
  lineHeight: 1.75,
  pH: _base["default"].spaces.xs,
  pV: _base["default"].spaces.xxs,
  mB: _base["default"].spaces.base,
  height: "34px",
  inputVariant: "border",
  searchVariant: "filled"
});
var menu = _objectSpread(_objectSpread({}, _base["default"].menu), {}, {
  pH: _base["default"].spaces.m,
  // for items
  pV: _base["default"].spaces.base,
  // for items
  logo: "40px",
  openWidth: "168px",
  iconSize: "22px"
});
var buttons = _objectSpread(_objectSpread({}, _base["default"].buttons), {}, {
  // PrimaryButton prop defaults.
  primary: {
    color: "primary"
  },
  // SecondaryButton prop defaults. SecondaryButton will be placed next to a
  // PrimaryButton, usually for a cancel action.
  secondary: {
    variant: "shadow"
  },
  // TertiaryButton prop defaults.
  tertiary: {
    variant: "transparent"
  },
  // DangerButton prop defaults. Usually for a delete action.
  danger: {
    variant: "filled",
    color: "error",
    textColor: "textInverted"
  }
});
var toggles = _objectSpread(_objectSpread({}, _base["default"].toggles), {}, {
  size: "small"
});
var tabs = _objectSpread(_objectSpread({}, _base["default"].tabs), {}, {
  color: "textSecondary",
  hoverColor: "text",
  activeColor: "text",
  disabledColor: "textTertiary",
  pH: _base["default"].spaces.base,
  variant: "default",
  fontSize: "13px"
});
var layouts = _objectSpread(_objectSpread({}, _base["default"].layouts), {}, {
  pH: _base["default"].spaces.m,
  backgroundColor: "backgroundSecondary"
});
var palette = {
  blue: "#3352FF",
  blue_1: "#EAEBF3",
  green: "#3DDC97",
  green_1: "#b1f1d5",
  red: "#FF5252",
  red_1: "#ffb8b8",
  yellow: "#FAC732",
  yellow_1: "#fdecb9",
  light: "#FFF",
  light_1: "#FAFAFA",
  light_2: "#F3F3F3",
  light_3: "#DEDEDE",
  dark: "#222222",
  dark_1: "#9DA0B4",
  dark_2: "#C2C5DC"
};
var newColors = _objectSpread(_objectSpread({}, _base.baseColorTokens), {}, {
  primary: palette.blue,
  primary_1: palette.blue_1,
  /* messages */
  success: palette.green,
  success_1: palette.green_1,
  warning: palette.yellow,
  warning_1: palette.yellow_1,
  error: palette.red,
  error_1: palette.red_1,
  border: palette.blue_1,
  // the most predominant background color: page, card, tab panel
  backgroundPrimary: palette.light,
  // the color *BEHIND* the page, card, tabs buttons, highlight row of
  // backgroundPrimary
  backgroundSecondary: palette.light_1,
  // alternate rows
  backgroundTertiary: palette.light_2,
  // background over backgroundTertiary, or hover / selected
  backgroundFourth: palette.light_3,
  // the base text color
  text: palette.dark,
  // text in disabled inputs, timestamp in List
  textSecondary: palette.dark_1,
  // disabled tabs, disabled text
  textTertiary: palette.dark_2,
  // text over dark backgrounds
  textInverted: palette.light_1,
  // color of labels; not textSecondary because in other themes it might have
  // another color
  label: palette.dark_1,
  focus: palette.blue,
  inputBackground: palette.light_1,
  inputButton: palette.dark,
  inputIcon: palette.dark_1,
  // some components will have different defaults in one theme or another - so
  // they need specific colors
  radioCheckInactive: palette.dark_2,
  tagBackground: palette.light_2,
  tableHeadText: "inherit",
  // Menu
  menuBackground: palette.light,
  //Menu v1
  menuIcon: palette.dark_2,
  menuText: palette.dark_1,
  menuTextActive: palette.dark,
  menuIconActive: palette.blue,
  menuSeparator: palette.blue_1 // same as border
});

/* document colors are used in Chat messages for messages of uploading a document */
var documentColors = {
  /* document colors */
  doc: "#5CC4FF",
  pdf: "#FF5151",
  text: "#5CC4FF",
  xls: "#00B235",
  generic: "#5CC4FF",
  docInverted: "#bfe8ff",
  pdfInverted: "#ffcccc",
  textInverted: "#bfe8ff",
  xlsInverted: "#bfffc2",
  genericInverted: "#bfe8ff"
};

/* profile colors are used in Chat messages for the participant names and/or avatar color  */
var profileColors = ["#7970EA", "#5CC4FF", "#EA5454", "#2F89FD", "#2D5D61", "#18BEBB", "#EA4C88", "#79B8D1", "#7F1F4D", "#F38081", "#FF2E62", "#3D83A8", "#AA95DA", "#9013FE", "#571E51", "#96A3BE", "#CE3171", "#510F76", "#A8C368", "#EC682C", "#385925"];
var appsColors = {
  chat: {
    mineBackground: "#17b76f",
    documents: _objectSpread({}, documentColors),
    profile: profileColors
  }
};
var colors = _objectSpread(_objectSpread({}, newColors), {}, {
  palette: palette,
  apps: appsColors
});
var airturn = _objectSpread(_objectSpread({}, _base["default"]), {}, {
  fontSizes: fontSizes,
  fontWeights: fontWeights,
  lineHeights: lineHeights,
  borderRadius: borderRadius,
  icons: icons,
  // iconFonts,
  fields: fields,
  menu: menu,
  buttons: buttons,
  toggles: toggles,
  tabs: tabs,
  layouts: layouts,
  colors: colors
});
var _default = airturn;
exports["default"] = _default;